/**
 * One Continue click as the paused line shows it: taken at once (the button
 * disabled), and let go when the panel's attempt SETTLES — finished, refused
 * (409 CONTINUE_IN_PROGRESS / NOT_CONTINUABLE), failed on the network, or
 * turned away by the panel's own one-at-a-time guard. It used to be let go
 * only when the panel withdrew `onContinue`, so an attempt that failed before
 * that left the button disabled for good and the person could not try again.
 *
 * The panels report their own failures (a notice, the row back as paused);
 * nothing is caught here, so an unexpected rejection still surfaces.
 */
export async function runContinueAttempt(
  onContinue: () => Promise<void>,
  setPending: (pending: boolean) => void,
): Promise<void> {
  setPending(true);
  try {
    await onContinue();
  } finally {
    setPending(false);
  }
}
